import React, { useEffect, useState } from 'react';
import { Box } from 'native-base';

export const FullScreenBox = ({
    children
}: { children: React.ReactNode }) => {

    const [viewportHeight, setViewportHeight] =
        useState<number>(window.innerHeight);

    useEffect(() => {

        const handleResize = () => {

            const height = window.innerHeight;
            setViewportHeight(height);
        };

        window.addEventListener('resize', handleResize);

        return () => {

            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <Box h={viewportHeight} mx={'auto'}>
            { children }
        </Box>
    );
};

export default FullScreenBox;
